module.exports = __webpack_public_path__ + "static/media/MrComplainBookCover.d1cc37de.jpg";